export const environment = {
  //SSO APIs
  SSOauthAPI: "https://uapi.auth.myzpax.com/api",
  ssoUserInfoAPI: "https://uapi.auth.myzpax.com/connect/userinfo",
  ssoConnectAPI: "https://uapi.auth.myzpax.com/connect/authorize",
  ssoLogoutAPI: "https://uapi.auth.myzpax.com/api/account/logout",
  ssoLoginUrl: "https://uat.auth.myzpax.com/sso/login",

  zpaxEsignatureDocumentRedirectEndPoint: "https://uat.myzpax.com/app/document-signature/documents",
  zpaxChangepasswordEndpoint:"https://uat.myzpax.com/user/password-and-security",
  zpaxPrivacyPolicyEndPoint: "https://uat.myzpax.com/privacy.html",
  zpaxTermsEndPoint: "https://uat.myzpax.com/terms.html",

  endpoint: "https://uapi.zrehabconnect.com/api/v1",
  sessionEncryptionKey:
    "fCCmUMuOM0kuDCuLe7naPOo6sNvlhXshFhZEVomw5XAS9vR7M0YGxbeaeYhiNmOC",
  idleTimeBeforeLocking: 1800,
  idleTimeBeforeTerminating: 2400,
  clientId: "8j57whgwfxxbchz4bj5cqcvueolyuwzt",
  userDetailsAPI: "/user/get",
  authorizationAPI: "/authorization",
  AWS_REGION: "us-east-1",
  AWS_ACCESS_KEY_ID: "",
  AWS_SECRET_ACCESS_KEY: "",
  AWS_SESSION_TOKEN: "",
  biDashboardSupersetDomain : 'https://4df6a8e3.us2a.app.preset.io',

  /**Matomo Analytics*/
  enableMatomo: false,
  matomo: {
    trackerUrl: "https://sandbox.matomo.z-pax.com/",
    siteId: 4
  },

  /**Pagesense */
  enablePagesense: false,
  pagesenseUrl: "https://cdn.pagesense.io/js/rehabconnectllc/b4f58c20f6384385a840cbf314bb6653.js",

  enableNewReactApp: true,
  postMessageTargets: ['https://uat.myzpax.com'],
  supportEmail: 'support@rehabconnect.com',

  /** CMI Connect Therapy Referrals iframe */
  therapyReferralUrl: "",
  therapyReferralFullAppUrl: "",
};
